var EpiMailChimp = function EpiMailChimp() {  
  var $formBtn = $('.mailchimp-form .o-form__submit');
  var origErrMsg = $('.mailchimp-form .Form__Errors .error-msg').text();
  
  $formBtn.on('click', function(e) {
    e.preventDefault();
    //e.stopPropagation();
    epiHelpers.disableSubmitButtonOnSend($formBtn);
    // Check for implicit dealer optin
    var options = {
      success: onFormSubmitSuccess,
      fail: onFormSubmitFail
    };
    if (validate()) {
      epiHelpers.sendLeadToMailchimp(options);
    } else {
      epiHelpers.reenableSubmitButton($formBtn);
      epiHelpers.scrollFormToFirstError();
    }
  });
  
  function validate() {
    var formValid = epiHelpers.validateForm(),
      phoneValid = epiHelpers.validatePhoneIfExists();
    if (formValid && phoneValid) {
      return true;
    } else {
      return false;
    }
  }
  
  function onFormSubmitSuccess(data) {
    // Mailchimp error will come through as a 200 from webservice
    // Need to check response for status:400, 500
    if (data.status !== undefined) {
      if (data.status !== 200) {
        displayErrorMessage(data.detail);
        return;
      }
    }
    if (data.Error !== undefined) {
      // The underlying connection was closed: An unexpected error occurred on a send.
      displayErrorMessage(data.Error);
      return;
    }
      // Show confirmation & purge any error copy
    $('.mailchimp-form .Form__Errors').addClass('hidden');
    $('.mailchimp-form .Form__MainBody').addClass('hidden');
    $('.mailchimp-form .Form__Confirmation').removeClass('hidden');
    // Callback for Contact a Dealer form...
    if (window.onEpiFormSubmitSuccess) {
      window.onEpiFormSubmitSuccess();
    }
  }
  
  function onFormSubmitFail(data) {
    displayErrorMessage(origErrMsg);
  }
  
  function displayErrorMessage(msg) {
    epiHelpers.reenableSubmitButton($formBtn);
    $('.mailchimp-form .Form__Errors .error-msg').text(msg)
    $('.mailchimp-form .Form__Errors').removeClass('hidden');
  }
}();
